<div class="p-4">
  <div class="flex justify-content-between align-items-center mb-4">
    <h1 class="text-2xl font-bold" style="color: #A102F2;">
      Comparateur d'Assurance Santé
    </h1>
    <div>
      <p-button
        label="Exemple"
        icon="pi pi-bolt"
        styleClass="p-button-outlined mr-2"
        (click)="loadExampleData()"
      ></p-button>
      <p-button
        label="Réinitialiser"
        icon="pi pi-refresh"
        styleClass="p-button-secondary"
        (click)="resetForm()"
      ></p-button>
    </div>
  </div>

  <div class="card">
    <p-toast></p-toast>

    <form [formGroup]="insuranceForm">
      <p-steps
        [model]="steps"
        [activeIndex]="activeIndex"
        [readonly]="false"
        (activeIndexChange)="goToStep($event)"
      ></p-steps>

      <div class="mt-4 wizard-content">
        <!-- Step 1: Informations personnelles -->
        <div *ngIf="activeIndex === 0" class="fadeIn">
          <div formGroupName="personalInfo">
            <fieldset>
              <legend>
                <i class="pi pi-user mr-2"></i>
                Informations personnelles
              </legend>

              <div class="grid">
                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="civilite" class="block mb-2">Civilité *</label>
                    <p-dropdown
                      id="civilite"
                      formControlName="civilite"
                      [options]="civiliteOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Sélectionner"
                      [style]="{ width: '100%' }"
                    ></p-dropdown>
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.civilite')?.invalid &&
                        insuranceForm.get('personalInfo.civilite')?.touched
                      "
                      class="p-error"
                      >La civilité est requise</small
                    >
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="nom" class="block mb-2">Nom *</label>
                    <input
                      id="nom"
                      formControlName="nom"
                      pInputText
                      class="w-full"
                      placeholder="Votre nom"
                    />
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.nom')?.invalid &&
                        insuranceForm.get('personalInfo.nom')?.touched
                      "
                      class="p-error"
                    >
                      <span *ngIf="insuranceForm.get('personalInfo.nom')?.errors?.['required'] || insuranceForm.get('personalInfo.nom')?.errors?.['requiredTrimmed']"
                        >Le nom est requis.</span
                      >
                      <span *ngIf="insuranceForm.get('personalInfo.nom')?.errors?.['specialCharacters']"
                        >Le nom ne doit contenir que des lettres, espaces, tirets et apostrophes.</span
                      >
                    </small>
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="prenom" class="block mb-2">Prénom *</label>
                    <input
                      id="prenom"
                      formControlName="prenom"
                      pInputText
                      class="w-full"
                      placeholder="Votre prénom"
                    />
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.prenom')?.invalid &&
                        insuranceForm.get('personalInfo.prenom')?.touched
                      "
                      class="p-error"
                    >
                      <span *ngIf="insuranceForm.get('personalInfo.prenom')?.errors?.['required'] || insuranceForm.get('personalInfo.prenom')?.errors?.['requiredTrimmed']"
                        >Le prénom est requis.</span
                      >
                      <span *ngIf="insuranceForm.get('personalInfo.prenom')?.errors?.['specialCharacters']"
                        >Le prénom ne doit contenir que des lettres, espaces, tirets et apostrophes.</span
                      >
                    </small>
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <!-- Ce libellé n'était associé à aucun champ (ni `for`, ni
                         `id` sur l'input) : le clic dessus ne donnait pas le
                         focus et les lecteurs d'écran annonçaient un champ
                         sans nom. -->
                    <label for="dateNaissance" class="block mb-2">Date de naissance *</label>
                    <input
                      id="dateNaissance"
                      type="text"
                      formControlName="dateNaissance"
                      pInputText
                      placeholder="JJ/MM/AAAA"
                      maxlength="10"
                      autocomplete="off"
                      class="w-full"
                      (input)="formatDateInput($event, 'dateNaissance')"
                    />
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.dateNaissance')?.invalid &&
                        insuranceForm.get('personalInfo.dateNaissance')?.touched
                      "
                      class="p-error"
                    >
                      <span *ngIf="insuranceForm.get('personalInfo.dateNaissance')?.errors?.['futureDate']"
                        >La date de naissance ne peut pas être dans le futur.</span>
                      <span *ngIf="!insuranceForm.get('personalInfo.dateNaissance')?.errors?.['futureDate']"
                        >La date de naissance est requise (format: JJ/MM/AAAA)</span>
                    </small>
                    <div class="age-label" *ngIf="ageAssurePrincipal !== null">
                      <i class="pi pi-user"></i> Âge : <strong>{{ ageAssurePrincipal }} ans</strong>
                    </div>
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="codePostalNaissance" class="block mb-2">Code postal de naissance *</label>
                    <input
                      id="codePostalNaissance"
                      formControlName="codePostalNaissance"
                      pInputText
                      class="w-full"
                      placeholder="69001"
                      maxlength="5"
                    />
                    <small class="text-gray-500">Utilisé pour générer le n° de sécurité sociale</small>
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="villeNaissance" class="block mb-2">Ville de naissance *</label>
                    <input
                      id="villeNaissance"
                      formControlName="villeNaissance"
                      pInputText
                      class="w-full"
                      placeholder="Lyon"
                    />
                    <small class="text-gray-500">Utilisé pour générer le n° de sécurité sociale</small>
                  </div>
                </div>

                <div class="col-12">
                  <div class="field">
                    <label for="adresse" class="block mb-2">Adresse *</label>
                    <input
                      id="adresse"
                      formControlName="adresse"
                      pInputText
                      class="w-full"
                      placeholder="123 Rue de la Paix"
                    />
                     <small
                      *ngIf="
                        insuranceForm.get('personalInfo.adresse')?.invalid &&
                        insuranceForm.get('personalInfo.adresse')?.touched
                      "
                      class="p-error"
                      >L'adresse est requise</small
                    >
                  </div>
                </div>

                <div class="col-12">
                  <div class="field">
                    <label for="complementAdresse" class="block mb-2">Complément d'adresse</label>
                    <input
                      id="complementAdresse"
                      formControlName="complementAdresse"
                      pInputText
                      class="w-full"
                      placeholder="Appartement, bâtiment..."
                    />
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="codePostal" class="block mb-2"
                      >Code postal *</label
                    >
                    <input
                      id="codePostal"
                      formControlName="codePostal"
                      pInputText
                      class="w-full"
                      placeholder="75001"
                    />
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.codePostal')?.invalid &&
                        insuranceForm.get('personalInfo.codePostal')?.touched
                      "
                      class="p-error"
                      >Code postal valide requis (5 chiffres)</small
                    >
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="ville" class="block mb-2">Ville *</label>
                    <input
                      id="ville"
                      formControlName="ville"
                      pInputText
                      class="w-full"
                      placeholder="Votre ville"
                    />
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.ville')?.invalid &&
                        insuranceForm.get('personalInfo.ville')?.touched
                      "
                      class="p-error"
                      >La ville est requise</small
                    >
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="pays" class="block mb-2">Pays *</label>
                    <input
                      id="pays"
                      formControlName="pays"
                      pInputText
                      class="w-full"
                      placeholder="Pays"
                      readonly
                    />
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.pays')?.invalid &&
                        insuranceForm.get('personalInfo.pays')?.touched
                      "
                      class="p-error"
                      >Le pays est requis</small
                    >
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="telephone1" class="block mb-2">Téléphone *</label>
                    <input
                      pInputText
                      id="telephone1"
                      type="tel"
                      formControlName="telephone1"
                      placeholder="+33 6 12 34 56 78"
                      class="w-full"
                    />
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.telephone1')?.invalid &&
                        insuranceForm.get('personalInfo.telephone1')?.touched
                      "
                      class="p-error"
                      >Le numéro de téléphone est requis ou invalide</small
                    >
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="email" class="block mb-2">Email *</label>
                    <input
                      id="email"
                      type="email"
                      formControlName="email"
                      pInputText
                      class="w-full"
                      placeholder="exemple@domaine.com"
                    />
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.email')?.invalid &&
                        insuranceForm.get('personalInfo.email')?.touched
                      "
                      class="p-error"
                    >
                      <span *ngIf="insuranceForm.get('personalInfo.email')?.errors?.['required'] || insuranceForm.get('personalInfo.email')?.errors?.['requiredTrimmed']"
                        >L'email est requis.</span
                      >
                      <span *ngIf="insuranceForm.get('personalInfo.email')?.errors?.['email']"
                        >L'email est invalide.</span
                      >
                      <span *ngIf="insuranceForm.get('personalInfo.email')?.errors?.['abstractEmail']"
                        >{{ insuranceForm.get('personalInfo.email')?.errors?.['abstractEmail'] }}</span
                      >
                    </small>
                    <small *ngIf="emailValidationState.checking" class="text-blue-600">
                      Verification email en cours...
                    </small>
                    <small *ngIf="!emailValidationState.checking && emailValidationState.valid === true" class="text-green-600">
                      {{ emailValidationState.message || 'Email valide.' }}
                    </small>
                    <small *ngIf="!emailValidationState.checking && emailValidationState.valid === false && !insuranceForm.get('personalInfo.email')?.errors?.['abstractEmail']" class="p-error">
                      {{ emailValidationState.message || 'Email non valide.' }}
                    </small>
                    <!--
                      `valid === null` : la vérification distante n'a pas pu
                      s'exécuter. Cet état n'affichait rien du tout ; le champ
                      reste utilisable mais l'agent doit savoir que seul le
                      format a été contrôlé.
                    -->
                    <small *ngIf="!emailValidationState.checking && emailValidationState.valid === null && emailValidationState.message" class="text-gray-500">
                      {{ emailValidationState.message }}
                    </small>
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label class="block mb-2">Date d'effet *</label>
                    <input
                      type="text"
                      formControlName="dateEffet"
                      pInputText
                      placeholder="JJ/MM/AAAA"
                      maxlength="10"
                      class="w-full"
                      (input)="formatDateInput($event, 'dateEffet')"
                    />
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.dateEffet')?.invalid &&
                        insuranceForm.get('personalInfo.dateEffet')?.touched
                      "
                      class="p-error"
                    >
                      La date d'effet est requise (format: JJ/MM/AAAA)
                    </small>
                  </div>
                </div>

                <!-- Section Résiliation contrat précédent -->
                <div formGroupName="termination" class="col-12">
                  <fieldset class="nested-fieldset">
                    <legend>
                      <i class="pi pi-file-excel mr-2"></i>
                      Résiliation contrat précédent
                    </legend>
                    
                    <div class="grid">
                      <div class="col-12">
                        <div class="field">
                          <label class="block mb-2">Votre client est-il déjà adhérent à un contrat individuel ?</label>
                          <div class="flex gap-4">
                            <div class="flex align-items-center">
                              <input
                                id="hasFormerContractOui"
                                type="radio"
                                class="native-radio"
                                formControlName="hasFormerContract"
                                [value]="true"
                              />
                              <label for="hasFormerContractOui" class="ml-2">Oui</label>
                            </div>
                            <div class="flex align-items-center">
                              <input
                                id="hasFormerContractNon"
                                type="radio"
                                class="native-radio"
                                formControlName="hasFormerContract"
                                [value]="false"
                              />
                              <label for="hasFormerContractNon" class="ml-2">Non</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="insuranceForm.get('personalInfo.termination.hasFormerContract')?.value" class="col-12">
                        <div class="grid">
                          <div class="col-12">
                            <div class="field">
                              <label class="block mb-2">Est-il assuré depuis 12 mois ?</label>
                              <div class="flex gap-4">
                                <div class="flex align-items-center">
                                  <input
                                    id="isInsuredFor12MonthsOui"
                                    type="radio"
                                    class="native-radio"
                                    formControlName="isInsuredFor12Months"
                                    [value]="true"
                                  />
                                  <label for="isInsuredFor12MonthsOui" class="ml-2">Oui</label>
                                </div>
                                <div class="flex align-items-center">
                                  <input
                                    id="isInsuredFor12MonthsNon"
                                    type="radio"
                                    class="native-radio"
                                    formControlName="isInsuredFor12Months"
                                    [value]="false"
                                  />
                                  <label for="isInsuredFor12MonthsNon" class="ml-2">Non</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 md:col-6">
                            <div class="field">
                              <label for="formerInsurer" class="block mb-2">Assureur précédent</label>
                              <input
                                id="formerInsurer"
                                formControlName="formerInsurer"
                                pInputText
                                class="w-full"
                                placeholder="Ex: AXA, MAAF, etc."
                              />
                            </div>
                          </div>
                          <div class="col-12 md:col-6">
                            <div class="field">
                              <label for="formerContractReference" class="block mb-2">Référence contrat précédent</label>
                              <input
                                id="formerContractReference"
                                formControlName="formerContractReference"
                                pInputText
                                class="w-full"
                                placeholder="Ex: 123456789"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>


                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="etatCivil" class="block mb-2">Etat civil *</label>
                    <p-dropdown
                      id="etatCivil"
                      formControlName="etatCivil"
                      [options]="EtatcivilOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Sélectionner"
                      [style]="{ width: '100%' }"
                    ></p-dropdown>
                     <small
                      *ngIf="
                        insuranceForm.get('personalInfo.etatCivil')?.invalid &&
                        insuranceForm.get('personalInfo.etatCivil')?.touched
                      "
                      class="p-error"
                      >L'Etat civil est requis</small
                    >
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="regime" class="block mb-2">Régime obligatoire *</label>
                    <p-dropdown
                      id="regime"
                      formControlName="regime"
                      [options]="regimeOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Sélectionner"
                      [style]="{ width: '100%' }"
                    ></p-dropdown>
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.regime')?.invalid &&
                        insuranceForm.get('personalInfo.regime')?.touched
                      "
                      class="p-error"
                      >Le régime est requis</small
                    >
                  </div>
                </div>

                <div class="col-12 md:col-4">
                  <div class="field">
                    <label for="categorieSocioProfessionnelle" class="block mb-2">Catégorie socio-professionnelle *</label>
                    <p-dropdown
                      id="categorieSocioProfessionnelle"
                      formControlName="categorieSocioProfessionnelle"
                      [options]="categorieSocioProfessionnelleOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Sélectionner"
                      [style]="{ width: '100%' }"
                    ></p-dropdown>
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.categorieSocioProfessionnelle')?.invalid &&
                        insuranceForm.get('personalInfo.categorieSocioProfessionnelle')?.touched
                      "
                      class="p-error"
                      >La catégorie socio-professionnelle est requise</small
                    >
                  </div>
                </div>

                <!-- Statut professionnel conditionnel pour CHEFS_D_ENTREPRISE -->
                <div *ngIf="insuranceForm.get('personalInfo.categorieSocioProfessionnelle')?.value === 'CHEFS_D_ENTREPRISE'" class="col-12 md:col-4">
                  <div class="field">
                    <label for="statutProfessionnel" class="block mb-2">Statut professionnel *</label>
                    <p-dropdown
                      id="statutProfessionnel"
                      formControlName="statutProfessionnel"
                      [options]="statutProfessionnelOptions"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Sélectionner"
                      [style]="{ width: '100%' }"
                    ></p-dropdown>
                    <small
                      *ngIf="
                        insuranceForm.get('personalInfo.statutProfessionnel')?.invalid &&
                        insuranceForm.get('personalInfo.statutProfessionnel')?.touched
                      "
                      class="p-error"
                      >Le statut professionnel est requis</small
                    >
                  </div>
                </div>

                <!-- Section Conjoint -->
                <!--
                  Le bloc reste fermé tant qu'aucun conjoint n'est déclaré : la
                  plupart des dossiers n'en comportent pas, et six champs vides
                  à parcourir alourdissaient la saisie pour rien.
                -->
                <div *ngIf="!aConjoint" class="col-12">
                  <p-button
                    label="Ajouter un conjoint"
                    icon="pi pi-heart"
                    styleClass="p-button-outlined p-button-sm"
                    (click)="addConjoint()"
                  ></p-button>
                </div>

                <div *ngIf="aConjoint" formGroupName="conjoint" class="col-12">
                  <fieldset class="nested-fieldset">
                    <legend>
                      <i class="pi pi-heart mr-2"></i>
                      Informations du conjoint
                    </legend>
                    <div class="flex justify-content-end mb-2">
                      <p-button
                        label="Supprimer conjoint"
                        icon="pi pi-trash"
                        styleClass="p-button-danger p-button-text p-button-sm"
                        (click)="removeConjoint()"
                      ></p-button>
                    </div>
                    <div class="grid">
                      <div class="col-12 md:col-4">
                        <div class="field">
                            <label for="conjointCivilite" class="block mb-2">Civilité</label>
                            <p-dropdown id="conjointCivilite" formControlName="civilite" [options]="civiliteOptions" optionLabel="label" optionValue="value" placeholder="- Choisir -" [style]="{ width: '100%' }"></p-dropdown>
                        </div>
                      </div>
                      <div class="col-12 md:col-4">
                        <div class="field">
                          <label for="conjointNom" class="block mb-2">Nom de famille</label>
                          <input id="conjointNom" formControlName="nom" pInputText class="w-full" placeholder="Nom de famille" />
                          <small
                            *ngIf="
                              insuranceForm.get('personalInfo.conjoint.nom')?.invalid &&
                              insuranceForm.get('personalInfo.conjoint.nom')?.touched
                            "
                            class="p-error"
                          >
                            <span *ngIf="insuranceForm.get('personalInfo.conjoint.nom')?.errors?.['specialCharacters']"
                              >Le nom ne doit contenir que des lettres, espaces, tirets et apostrophes.</span
                            >
                          </small>
                        </div>
                      </div>
                      <div class="col-12 md:col-4">
                        <div class="field">
                          <label for="conjointPrenom" class="block mb-2">Prénom</label>
                          <input id="conjointPrenom" formControlName="prenom" pInputText class="w-full" placeholder="Prénom" />
                          <small
                            *ngIf="
                              insuranceForm.get('personalInfo.conjoint.prenom')?.invalid &&
                              insuranceForm.get('personalInfo.conjoint.prenom')?.touched
                            "
                            class="p-error"
                          >
                            <span *ngIf="insuranceForm.get('personalInfo.conjoint.prenom')?.errors?.['specialCharacters']"
                              >Le prénom ne doit contenir que des lettres, espaces, tirets et apostrophes.</span
                            >
                          </small>
                        </div>
                      </div>
                      <div class="col-12 md:col-4">
                        <div class="field">
                          <label for="conjointEmail" class="block mb-2">Email</label>
                          <input id="conjointEmail" type="email" formControlName="email" pInputText class="w-full" placeholder="Email" />
                          <small
                            *ngIf="
                              insuranceForm.get('personalInfo.conjoint.email')?.invalid &&
                              insuranceForm.get('personalInfo.conjoint.email')?.touched
                            "
                            class="p-error"
                          >
                            <span *ngIf="insuranceForm.get('personalInfo.conjoint.email')?.errors?.['required'] || insuranceForm.get('personalInfo.conjoint.email')?.errors?.['requiredTrimmed']"
                              >L'email du conjoint est requis.</span
                            >
                            <span *ngIf="insuranceForm.get('personalInfo.conjoint.email')?.errors?.['email']"
                              >L'email du conjoint est invalide.</span
                            >
                            <span *ngIf="insuranceForm.get('personalInfo.conjoint.email')?.errors?.['sameAsPrincipalEmail']"
                              >{{ insuranceForm.get('personalInfo.conjoint.email')?.errors?.['sameAsPrincipalEmail'] }}</span
                            >
                            <span *ngIf="insuranceForm.get('personalInfo.conjoint.email')?.errors?.['abstractEmail']"
                              >{{ insuranceForm.get('personalInfo.conjoint.email')?.errors?.['abstractEmail'] }}</span
                            >
                          </small>
                          <small *ngIf="coEmailValidationState.checking" class="text-blue-600">
                            Verification email conjoint en cours...
                          </small>
                          <small *ngIf="!coEmailValidationState.checking && coEmailValidationState.valid === true" class="text-green-600">
                            {{ coEmailValidationState.message || 'Email conjoint valide.' }}
                          </small>
                          <small *ngIf="!coEmailValidationState.checking && coEmailValidationState.valid === null && coEmailValidationState.message" class="text-gray-500">
                            {{ coEmailValidationState.message }}
                          </small>
                          <small *ngIf="!coEmailValidationState.checking && coEmailValidationState.valid === false && !insuranceForm.get('personalInfo.conjoint.email')?.errors?.['abstractEmail']" class="p-error">
                            {{ coEmailValidationState.message || 'Email conjoint non valide.' }}
                          </small>
                        </div>
                      </div>
                      <div class="col-12 md:col-4">
                        <div class="field">
                          <label for="conjointDateNaissance" class="block mb-2">Date de naissance</label>
                          <input
                            id="conjointDateNaissance"
                            type="text"
                            formControlName="dateNaissance"
                            pInputText
                            placeholder="JJ/MM/AAAA"
                            maxlength="10"
                            autocomplete="off"
                            class="w-full"
                            (input)="formatDateInput($event, 'conjoint.dateNaissance')"
                          />
                          <small
                            *ngIf="
                              insuranceForm.get('personalInfo.conjoint.dateNaissance')?.invalid &&
                              insuranceForm.get('personalInfo.conjoint.dateNaissance')?.touched
                            "
                            class="p-error"
                          >
                            <!--
                              Seule la clé `invalidDate` était testée : les
                              autres erreurs de date (format, jour, mois, année,
                              date future) affichaient un bloc rouge vide.
                            -->
                            <span *ngIf="insuranceForm.get('personalInfo.conjoint.dateNaissance')?.errors?.['futureDate']"
                              >La date de naissance ne peut pas être dans le futur.</span>
                            <span *ngIf="!insuranceForm.get('personalInfo.conjoint.dateNaissance')?.errors?.['futureDate']"
                              >Format de date invalide (JJ/MM/AAAA).</span>
                          </small>
                          <div class="age-label" *ngIf="ageConjoint !== null">
                            <i class="pi pi-user"></i> Âge : <strong>{{ ageConjoint }} ans</strong>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 md:col-4">
                        <div class="field">
                          <label for="conjointRegime" class="block mb-2">Régime</label>
                          <p-dropdown 
                            id="conjointRegime" 
                            formControlName="regime" 
                            [options]="regimeOptions" 
                            optionLabel="label" 
                            optionValue="value" 
                            placeholder="- Choisir -" 
                            [style]="{ width: '100%' }"
                          ></p-dropdown>
                        </div>
                      </div>
                    </div>
                    <!--
                      Le groupe conjoint porte l'erreur `incompleteConjoint` :
                      elle bloquait le formulaire sans qu'aucun message ne soit
                      affiché nulle part. On indique désormais précisément les
                      champs restant à remplir.
                    -->
                    <small
                      *ngIf="conjointChampsManquants.length"
                      class="p-error block mt-2"
                    >
                      Conjoint incomplet : renseignez
                      {{ conjointChampsManquants.join(', ') }}.
                      Utilisez « Supprimer conjoint » s'il n'y a pas de conjoint.
                    </small>
                  </fieldset>
                </div>

                <!-- Section Enfants -->
                <div class="col-12">
                  <fieldset class="nested-fieldset">
                    <legend>
                      <i class="pi pi-users mr-2"></i>
                      Enfants à charge
                    </legend>
                    <div formArrayName="enfants">
                      <div *ngFor="let enfant of enfants.controls; let i = index" [formGroupName]="i" class="grid align-items-center p-2 mb-2 border-1 border-gray-200 rounded-md bg-gray-50">
                        <div class="col-12 md:col-4">
                          <div class="field mb-0">
                            <label [for]="'enfantCivilite' + i" class="block mb-2 text-sm">Civilité</label>
                            <p-dropdown [id]="'enfantCivilite' + i" formControlName="civilite" [options]="civiliteOptions" optionLabel="label" optionValue="value" placeholder="- Choisir -" [style]="{ width: '100%' }"></p-dropdown>
                          </div>
                        </div>
                        <div class="col-12 md:col-4">
                          <div class="field mb-0">
                            <label [for]="'enfantNom' + i" class="block mb-2 text-sm">Nom de famille</label>
                            <input [id]="'enfantNom' + i" formControlName="nom" pInputText class="w-full" placeholder="Nom de famille" />
                            <small
                              *ngIf="
                                enfants.at(i).get('nom')?.invalid &&
                                enfants.at(i).get('nom')?.touched
                              "
                              class="p-error text-xs"
                            >
                              <span *ngIf="enfants.at(i).get('nom')?.errors?.['required'] || enfants.at(i).get('nom')?.errors?.['requiredTrimmed']"
                                >Le nom est requis.</span
                              >
                              <span *ngIf="enfants.at(i).get('nom')?.errors?.['specialCharacters']"
                                >Lettres, espaces, tirets et apostrophes uniquement.</span
                              >
                            </small>
                          </div>
                        </div>
                        <div class="col-12 md:col-4">
                          <div class="field mb-0">
                            <label [for]="'enfantPrenom' + i" class="block mb-2 text-sm">Prénom</label>
                            <input [id]="'enfantPrenom' + i" formControlName="prenom" pInputText class="w-full" placeholder="Prénom" />
                            <small
                              *ngIf="
                                enfants.at(i).get('prenom')?.invalid &&
                                enfants.at(i).get('prenom')?.touched
                              "
                              class="p-error text-xs"
                            >
                              <span *ngIf="enfants.at(i).get('prenom')?.errors?.['required'] || enfants.at(i).get('prenom')?.errors?.['requiredTrimmed']"
                                >Le prénom est requis.</span
                              >
                              <span *ngIf="enfants.at(i).get('prenom')?.errors?.['specialCharacters']"
                                >Lettres, espaces, tirets et apostrophes uniquement.</span
                              >
                            </small>
                          </div>
                        </div>
                        <div class="col-12 md:col-6">
                          <div class="field mb-0">
                            <label [for]="'enfantDateNaissance' + i" class="block mb-2 text-sm">Date de naissance</label>
                            <input
                              [id]="'enfantDateNaissance' + i"
                              type="text"
                              formControlName="dateNaissance"
                              pInputText
                              placeholder="JJ/MM/AAAA"
                              maxlength="10"
                              autocomplete="off"
                              class="w-full"
                              (input)="formatDateInput($event, 'enfants.' + i + '.dateNaissance')"
                            />
                            <small
                              *ngIf="
                                enfants.at(i).get('dateNaissance')?.invalid &&
                                enfants.at(i).get('dateNaissance')?.touched
                              "
                              class="p-error text-xs"
                            >
                              <span *ngIf="enfants.at(i).get('dateNaissance')?.errors?.['futureDate']"
                                >La date de naissance ne peut pas être dans le futur.</span>
                              <span *ngIf="!enfants.at(i).get('dateNaissance')?.errors?.['futureDate']"
                                >La date de naissance est requise (format: JJ/MM/AAAA)</span>
                            </small>
                            <div class="age-label" *ngIf="getAgeEnfant(i) !== null">
                              <i class="pi pi-user"></i> Âge : <strong>{{ getAgeEnfant(i) }} ans</strong>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 md:col-5">
                          <div class="field mb-0">
                            <label [for]="'enfantRegime' + i" class="block mb-2 text-sm">Régime</label>
                            <p-dropdown [id]="'enfantRegime' + i" formControlName="regime" [options]="regimeOptions" optionLabel="label" optionValue="value" placeholder="- Choisir -" [style]="{ width: '100%' }"></p-dropdown>
                          </div>
                        </div>
                        <div class="col-12 md:col-1 flex align-items-center justify-content-end">
                          <p-button icon="pi pi-trash" styleClass="p-button-danger p-button-text" (click)="removeEnfant(i)"></p-button>
                        </div>
                      </div>
                    </div>
                    <p-button label="Ajouter un enfant" icon="pi pi-plus" styleClass="p-button-outlined p-button-sm mt-2" (click)="addEnfant()"></p-button>
                  </fieldset>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <!-- Step 2: Comparer -->
        <div *ngIf="activeIndex === 1" class="fadeIn">
          <div formGroupName="coverageSliders">
            <div class="card p-4">
              <h2 class="text-xl font-medium mb-4">
                <i class="pi pi-sliders-h mr-2"></i>
                Comparer les garanties
                <span *ngIf="isComparing" class="ml-3 text-orange-500 font-normal text-base">
                  <i class="pi pi-lock mr-1"></i>
                  Comparaison en cours - Sliders bloqués
                </span>
              </h2>

              <!-- Section d'upload PDF -->
              <div class="card p-3 mb-4 border-1 border-blue-200 bg-blue-50">
                <h3 class="text-lg font-medium mb-3">
                  <i class="pi pi-file-pdf mr-2 text-red-500"></i>
                  Importer les garanties depuis un PDF
                </h3>
                <p class="text-sm text-gray-600 mb-3">
                  Vous pouvez attacher le PDF de votre contrat actuel pour remplir automatiquement les sliders selon vos garanties existantes.
                </p>
                
                <div class="grid">
                  <div class="col-12 md:col-6">
                    <div class="field">
                      <label for="pdfFile" class="block mb-2">Fichier PDF du contrat</label>
                      <input 
                        type="file" 
                        id="pdfFile" 
                        accept=".pdf"
                        (change)="onPdfFileSelected($event)"
                        class="w-full p-2 border-1 border-gray-300 rounded-md"
                        [disabled]="isExtractingPdf || isComparing"
                      />
                      <small class="text-gray-500">Formats acceptés: PDF uniquement</small>
                    </div>
                  </div>
                  
                  <div class="col-12 md:col-3">
                    <div class="field">
                      <label for="insurerInput" class="block mb-2">Assureur</label>
                      <input 
                        type="text" 
                        id="insurerInput"
                        [value]="selectedInsurer"
                        (input)="selectedInsurer = $any($event.target).value"
                        pInputText 
                        placeholder="Ex: ALPTIS, APIVIA, UTWIN..."
                        class="w-full"
                        [disabled]="isExtractingPdf || isComparing"
                      />
                      <small class="text-gray-500">Saisissez le nom de votre assureur</small>
                    </div>
                  </div>
                  
                  <div class="col-12 md:col-3">
                    <div class="field">
                      <label for="levelName" class="block mb-2">Formule/Niveau</label>
                      <input 
                        type="text" 
                        id="levelName" 
                        [value]="selectedLevelName"
                        (input)="selectedLevelName = $any($event.target).value"
                        pInputText 
                        placeholder="Ex: Niveau 1, Formule Confort..."
                        class="w-full"
                        [disabled]="isExtractingPdf || isComparing"
                      />
                      <small class="text-gray-500">Indiquez le niveau de votre contrat</small>
                    </div>
                  </div>
                  
                  <div class="col-12 md:col-2 flex align-items-end">
                    <p-button 
                      label="Extraire"
                      icon="pi pi-upload"
                      (click)="extractPdfData()"
                      [disabled]="!selectedPdfFile || !selectedInsurer || !selectedLevelName || isExtractingPdf || isComparing"
                      [loading]="isExtractingPdf"
                      styleClass="w-full"
                    ></p-button>
                  </div>
                </div>
                
                <!-- Debug info temporaire -->
                <div class="mt-2 text-sm text-gray-600">
                  <strong>Debug:</strong> 
                  PDF: {{ selectedPdfFile ? 'OK' : 'MANQUE' }} | 
                  Assureur: {{ selectedInsurer || 'VIDE' }} | 
                  Niveau: {{ selectedLevelName || 'VIDE' }} | 
                  Extraction: {{ isExtractingPdf ? 'EN COURS' : 'PRET' }}
                </div>
                
                <div *ngIf="pdfExtractionMessage" class="mt-3">
                  <p-message 
                    [severity]="pdfExtractionMessage.type" 
                    [text]="pdfExtractionMessage.text"
                    [closable]="true"
                  ></p-message>
                </div>
              </div>
              <div class="grid">
                <!-- Hospitalisation -->
                <div class="col-12 md:col-6">
                  <div class="field">
                    <label id="lbl-hospitalisation" class="block mb-2">Hospitalisation</label>
                    <p-slider formControlName="hospitalisation" [ariaLabelledBy]="'lbl-hospitalisation'" [min]="0" [max]="1000" [step]="5"></p-slider>
                    <span class="ml-2 font-bold">{{ getDisplayValue('hospitalisation') }}</span>
                  </div>
                </div>

                <!-- Honoraires -->
                <div class="col-12 md:col-6">
                  <div class="field">
                    <label id="lbl-honoraires" class="block mb-2">Honoraires</label>
                    <p-slider formControlName="honoraires" [ariaLabelledBy]="'lbl-honoraires'" [min]="0" [max]="500" [step]="5"></p-slider>
                    <span class="ml-2 font-bold">{{ getDisplayValue('honoraires') }}</span>
                  </div>
                </div>

                <!-- Chambre particulière -->
                <div class="col-12 md:col-6">
                  <div class="field">
                    <label id="lbl-chambreParticuliere" class="block mb-2">Chambre particulière</label>
                    <p-slider formControlName="chambreParticuliere" [ariaLabelledBy]="'lbl-chambreParticuliere'" [min]="0" [max]="200" [step]="5"></p-slider>
                    <span class="ml-2 font-bold">{{ getDisplayValue('chambreParticuliere') }}</span>
                  </div>
                </div>

                <!-- Prothèse fixe (Dentaire) -->
                <div class="col-12 md:col-6">
                  <div class="field">
                    <label id="lbl-dentaire" class="block mb-2">Prothèse fixe</label>
                    <p-slider formControlName="dentaire" [ariaLabelledBy]="'lbl-dentaire'" [min]="0" [max]="1000" [step]="5"></p-slider>
                    <span class="ml-2 font-bold">{{ getDisplayValue('dentaire') }}</span>
                  </div>
                </div>

                <!-- Orthodontie -->
                <div class="col-12 md:col-6">
                  <div class="field">
                    <label id="lbl-orthodontie" class="block mb-2">Orthodontie</label>
                    <p-slider formControlName="orthodontie" [ariaLabelledBy]="'lbl-orthodontie'" [min]="0" [max]="1000" [step]="5"></p-slider>
                    <span class="ml-2 font-bold">{{ getDisplayValue('orthodontie') }}</span>
                  </div>
                </div>

                <!-- Forfait dentaire -->
                <div class="col-12 md:col-6">
                  <div class="field">
                    <label id="lbl-forfaitDentaire" class="block mb-2">Forfait dentaire</label>
                    <p-slider formControlName="forfaitDentaire" [ariaLabelledBy]="'lbl-forfaitDentaire'" [min]="0" [max]="1000" [step]="5"></p-slider>
                    <span class="ml-2 font-bold">{{ getDisplayValue('forfaitDentaire') }}</span>
                  </div>
                </div>

                <!-- Forfait optique -->
                <div class="col-12 md:col-6">
                  <div class="field">
                    <label id="lbl-forfaitOptique" class="block mb-2">Forfait optique</label>
                    <p-slider formControlName="forfaitOptique" [ariaLabelledBy]="'lbl-forfaitOptique'" [min]="0" [max]="1000" [step]="5"></p-slider>
                    <span class="ml-2 font-bold">{{ getDisplayValue('forfaitOptique') }}</span>
                  </div>
                </div>

                <!-- Médecine complémentaire -->
                <div class="col-12 md:col-6">
                  <div class="field">
                    <label id="lbl-medecineComplementaire" class="block mb-2">Médecine complémentaire</label>
                    <p-slider formControlName="medecineComplementaire" [ariaLabelledBy]="'lbl-medecineComplementaire'" [min]="0" [max]="500" [step]="10"></p-slider>
                    <span class="ml-2 font-bold">{{ getDisplayValue('medecineComplementaire') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 3: Résultats -->
        <div *ngIf="activeIndex === 2" class="fadeIn">
          <div class="card p-4">
            <h2 class="text-xl font-medium mb-4 flex align-items-center justify-content-between flex-wrap gap-2">
              <span class="flex align-items-center gap-2">
                <i class="pi pi-chart-bar mr-2"></i>
                <span>Résultats de la comparaison</span>
                <span class="text-base font-normal text-600 ml-2" *ngIf="clientFullName">
                  - <strong>{{ clientFullName }}</strong>
                </span>
                <span *ngIf="comparisonExecutionDate" class="text-sm font-normal text-500 ml-1">
                  - Exécuté le {{ comparisonExecutionDate | date:'dd/MM/yyyy à HH:mm' }}
                </span>
              </span>
            </h2>

            
            <div *ngIf="results.length > 0 && canManageCommissions" class="results-actions" style="margin-bottom: 1rem;">
              <p-button type="button" [label]="showCommissionPanel ? 'Masquer commissions' : 'Modifier commissions'"
                [icon]="showCommissionPanel ? 'pi pi-chevron-up' : 'pi pi-sliders-h'" styleClass="p-button-outlined"
                (onClick)="toggleCommissionPanel()">
              </p-button>
            </div>

            <!-- Panneau de modification des commissions -->
            <div *ngIf="results.length > 0 && canManageCommissions && showCommissionPanel" class="commission-panel">
              <div class="commission-panel-header">
                <h4><i class="pi pi-sliders-h"></i> Modifier les taux de commission</h4>
                <p class="commission-panel-subtitle">Ajustez les commissions pour chaque assureur et relancez la
                  comparaison</p>
              </div>

              <div class="commission-grid">
                <div *ngFor="let item of commissionItems; trackBy: trackByKey" class="commission-item">
                  <div class="commission-insurer">
                    <img [src]="getInsurerLogo(item.insurer)" [alt]="item.insurer" class="commission-logo" />
                    <span class="commission-insurer-name">{{ getInsurerFirstWord(item.insurer) }}</span>
                  </div>
                  <div class="commission-selector">
                    <select class="commission-select" [ngModel]="item.selectedValue"
                      [ngModelOptions]="{ standalone: true }" (ngModelChange)="onCommissionSelect(item, $event)"
                      [disabled]="isComparing">
                      <option *ngFor="let opt of item.options" [ngValue]="opt.value">
                        {{ opt.label }}
                      </option>
                    </select>
                    <span *ngIf="isItemChanged(item)" class="commission-changed-badge" pTooltip="Valeur modifiée">
                      <i class="pi pi-exclamation-circle"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="commission-actions">
                <p-button type="button" label="Réinitialiser" icon="pi pi-refresh"
                  styleClass="p-button-secondary p-button-text" (onClick)="resetCommissions()"
                  [disabled]="!hasChanges || isComparing">
                </p-button>
                <p-button type="button" label="Relancer la comparaison" icon="pi pi-sync"
                  (onClick)="rerunWithNewCommissions()" [disabled]="!hasChanges || isComparing" [loading]="isComparing">
                </p-button>
              </div>
            </div>

            <div *ngIf="results.length > 0; else noResults" class="comparison-table-container">
              <table class="w-full comparison-table custom-table">
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center needs-column-header assurance-header compact-header">
                      <div class="needs-header-container">
                        <span class="needs-header-title">VOS BESOINS / GARANTIES ACTUELLES</span>
                      </div>
                    </th>
                    <th *ngFor="let result of results" class="text-center assurance-header compact-header">
                      <div class="insurer-logo-container">
                        <img [src]="getInsurerLogo(result.insurer || result.assurance)" 
                             [alt]="getInsurerFirstWord(result.insurer || result.assurance)" 
                             class="insurer-logo"
                             [title]="result.insurer || result.assurance" />
                      </div>
                      <div class="product-badges" style="display: flex; justify-content: center; margin-top: 8px;">
                        <p-dropdown 
                          [options]="getCommissionOptionsForResult(result)"
                          [(ngModel)]="result.selectedCommission"
                          [ngModelOptions]="{standalone: true}"
                          optionLabel="label"
                          optionValue="value"
                          placeholder="Commission"
                          [style]="{ 'min-width': '120px', 'font-size': '0.75rem' }"
                          (onChange)="onCommissionChange(result)"
                          appendTo="body">
                        </p-dropdown>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Row for Checkbox Selection -->
                  <tr class="border-b checkbox-row">
                    <td class="font-bold">Sélectionner</td>
                    <td class="needs-cell needs-cell--meta"></td>

                    <td *ngFor="let result of results" class="text-center">
                      <p-checkbox 
                        [binary]="true" 
                        [(ngModel)]="result.selectedForQuote"
                        [ngModelOptions]="{standalone: true}"
                        (onChange)="onSingleCheckboxChange()"
                        pTooltip="Sélectionner {{ result.insurer || result.assurance }}">
                      </p-checkbox>
                    </td>
                  </tr>




                  <!-- Row for Produit -->
                  <tr class="border-b product-row">
                    <td class="font-bold">Produit</td>
                    <td class="needs-cell needs-cell--meta product-cell"></td>
                    <td *ngFor="let result of results" class="text-center product-cell">
                      <div class="product-name pt-2">
                        {{ result.contractName || result.formule }}
                      </div>
                    </td>
                  </tr>

                  <!-- Row for Formule -->
                  <tr class="border-b formula-row">
                    <td class="font-bold">Niveau</td>
                    <td class="needs-cell needs-cell--meta formula-cell"></td>
                    <td *ngFor="let result of results" class="text-center formula-cell">
                      <div class="formula-level text-sm text-gray-600 pb-2">
                        {{ result.levelName || result.formule }}
                      </div>
                    </td>
                  </tr>

                  <!-- Rows for Garanties -->
                  <tr *ngFor="let garantie of garanties; let gi = index">
                    <td class="font-bold">{{ garantie.label }}</td>
                    <td class="needs-cell needs-cell--in-block text-center"
                        [class.needs-cell--block-start]="gi === 0"
                        [class.needs-cell--block-end]="gi === garanties.length - 1"
                        [style.border-bottom]="gi === garanties.length - 1 ? '2px solid #A102F2' : null">
                      <span class="needs-value">{{ getUserNeedDisplay(garantie.formControlName, garantie.unit) }}</span>
                    </td>

                    <td *ngFor="let result of results" 
                        class="text-center" 
                        [ngClass]="getProximityBasedCoverageClass(result.garanties[garantie.formControlName], insuranceForm.get('coverageSliders.' + garantie.formControlName)?.value, garantie.formControlName)"
                        [title]="getProximityDescription(result.garanties[garantie.formControlName], insuranceForm.get('coverageSliders.' + garantie.formControlName)?.value) + ' (Score: ' + getProximityScore(result.garanties[garantie.formControlName], insuranceForm.get('coverageSliders.' + garantie.formControlName)?.value) + '%)'">
                      <ng-container *ngIf="result.garanties && result.garanties[garantie.formControlName] !== undefined && result.garanties[garantie.formControlName] !== null && result.garanties[garantie.formControlName] !== '-' && result.garanties[garantie.formControlName] !== 0; else noValue">
                                                <ng-container *ngIf="isNumeric(result.garanties[garantie.formControlName]); else stringValue">
                          {{ result.garanties[garantie.formControlName] }}{{ garantie.unit }}
                        </ng-container>
                        <ng-template #stringValue>
                          {{ result.garanties[garantie.formControlName] }}
                        </ng-template>
                      </ng-container>
                      <ng-template #noValue>-</ng-template>
                    </td>
                  </tr>

                  <!-- Footer row for Correspondance -->
                  <tr>
                    <td class="font-bold">Correspondance</td>
                    <td class="needs-cell needs-cell-footer"></td>

                    <td *ngFor="let result of results" class="text-center font-bold">
                        {{ result.correspondencePercentage }}%
                    </td>
                  </tr>

                  <!-- Footer row for Point Faible -->
                  <tr class="border-b">
                    <td class="font-bold">Point Faible</td>
                    <td class="needs-cell needs-cell-footer"></td>

                    <td *ngFor="let result of results; let i = index" class="text-center">
                      <p-button 
                        label="Détail" 
                        icon="pi pi-info-circle" 
                        styleClass="p-button-outlined p-button-sm"
                        (click)="showWeakPointDetails(result)">
                      </p-button>
                    </td>
                  </tr>

                  

                  <!-- Row for Automatic Pricing -->
                  <tr class="border-b price-row">
                    <td class="font-bold">Prix</td>
                    <td class="needs-cell needs-cell-footer"></td>

                    <td *ngFor="let result of results" class="text-center">
                      <div class="price-container">
                        <ng-container *ngIf="result.isAprilProduct">
                          <div *ngIf="isNumeric(result.tarifGlobal)">
                            <span class="font-bold text-xl text-primary">{{ result.tarifGlobal | currency:'EUR':'symbol':'1.2-2' }}</span>
                            <div class="text-xs text-gray-500">/ mois</div>
                          </div>
                          <span *ngIf="!isNumeric(result.tarifGlobal)" class="text-gray-400" [attr.title]="result.pricingDetail || null">
                            {{ result.tarifGlobal || 'N/A' }}
                            <small *ngIf="result.pricingDetail" class="pricing-hint">{{ result.pricingDetail }}</small>
                          </span>
                        </ng-container>
                        <ng-container *ngIf="!result.isAprilProduct">
                          <div *ngIf="isNumeric(result.prix)">
                            <span class="font-bold text-xl text-primary">{{ result.prix | currency:'EUR':'symbol':'1.2-2' }}</span>
                            <div class="text-xs text-gray-500">/ mois</div>
                          </div>
                          <span *ngIf="!isNumeric(result.prix)" class="text-gray-400" [attr.title]="result.pricingDetail || null">
                            {{ result.prix }}
                            <small *ngIf="result.pricingDetail" class="pricing-hint">{{ result.pricingDetail }}</small>
                          </span>
                        </ng-container>
                      </div>
                    </td>
                  </tr>

                  <!-- Footer row for actions -->
                  <tr class="footer-row">
                    <td></td>
                    <td class="needs-cell needs-cell-footer"></td>
                    <td *ngFor="let result of results" class="text-center py-3">
                      <div class="flex flex-column gap-2 align-items-center">
                        <p-button 
                          label="Choisir" 
                          icon="pi pi-check" 
                          styleClass="p-button-primary w-full"
                          (click)="onFormuleSelect(result, result.formule)">
                        </p-button>
                        
                        <ng-container *ngIf="isNumeric(result.prix) || isNumeric(result.tarifGlobal)">
                          
                          <!-- Standard Quote button for others (not April, not Utwin, not Alptis, not Neoliane, not Zenioo, not ECA, not Generali, not Apivia) -->
                          <p-button 
                            *ngIf="!result.isAprilProduct && !result.assurance.toLowerCase().includes('utwin') && !result.assurance.toLowerCase().includes('alptis') && !result.assurance.toLowerCase().includes('apivia') && !result.assurance.toLowerCase().includes('neoliane') && !result.assurance.toLowerCase().includes('néoliane') && !isZeniooOffer(result.assurance) && !result.assurance.toLowerCase().includes('eca') && !result.assurance.toLowerCase().includes('generali')"
                            label="Devis"
                            icon="pi pi-file-pdf" 
                            styleClass="p-button-outlined w-full"
                            (click)="generateQuote(result, 'telechargement')">
                          </p-button>

                          <!-- Apivia: Devis + Souscrire buttons -->
                          <ng-container *ngIf="result.assurance.toLowerCase().includes('apivia')">
                            <p-button 
                              label="Devis"
                              icon="pi pi-file-pdf" 
                              styleClass="p-button-outlined w-full"
                              (click)="generateQuote(result, 'telechargement')">
                            </p-button>
                            <p-button 
                              label="Souscrire"
                              icon="pi pi-external-link" 
                              styleClass="p-button-info w-full"
                              (click)="openApiviaPortal()">
                            </p-button>
                          </ng-container>

                          <!-- April: Devis + Souscrire buttons -->
                          <ng-container *ngIf="result.isAprilProduct">
                            <p-button 
                              label="Devis"
                              icon="pi pi-file-pdf" 
                              styleClass="p-button-outlined w-full"
                              (click)="generateQuote(result, 'telechargement')">
                            </p-button>
                            <p-button 
                              label="Souscrire"
                              icon="pi pi-pencil" 
                              styleClass="p-button-info w-full"
                              (click)="startAprilSubscription(result)">
                            </p-button>
                          </ng-container>
                          
                          <!-- Néoliane: Devis + Souscrire buttons -->
                          <ng-container *ngIf="result.assurance.toLowerCase().includes('neoliane') || result.assurance.toLowerCase().includes('néoliane')">
                            <p-button 
                              label="Devis"
                              icon="pi pi-file-pdf" 
                              styleClass="p-button-outlined w-full"
                              (click)="generateQuote(result, 'telechargement')">
                            </p-button>
                            <p-button 
                              label="Souscrire"
                              icon="pi pi-pencil" 
                              styleClass="p-button-info w-full"
                              (click)="startNeolianeSubscription(result)">
                            </p-button>
                          </ng-container>
                          
                          <!-- Utwin: Devis + Souscrire buttons -->
                          <ng-container *ngIf="result.assurance.toLowerCase().includes('utwin')">
                            <p-button 
                              label="Devis"
                              icon="pi pi-file-pdf" 
                              styleClass="p-button-outlined w-full"
                              (click)="generateQuote(result, 'envoiParEmail')">
                            </p-button>
                            <p-button 
                              label="Souscrire"
                              icon="pi pi-pencil" 
                              styleClass="p-button-info w-full"
                              (click)="startUtwinSubscription(result)">
                            </p-button>
                          </ng-container>

                          <!-- Zenioo: Devis + Souscrire buttons -->
                          <ng-container *ngIf="isZeniooOffer(result.assurance)">
                            <p-button 
                              label="Devis"
                              icon="pi pi-file-pdf" 
                              styleClass="p-button-outlined w-full"
                              (click)="generateQuote(result, 'telechargement')">
                            </p-button>
                            <p-button 
                              label="Souscrire"
                              icon="pi pi-pencil" 
                              styleClass="p-button-info w-full"
                              (click)="startZeniooSubscription(result)">
                            </p-button>
                          </ng-container>

                          <!-- Alptis: Souscrire button -->
                          <ng-container *ngIf="result.assurance.toLowerCase().includes('alptis')">
                            <p-button 
                              label="Devis"
                              icon="pi pi-file-pdf" 
                              styleClass="p-button-outlined w-full"
                              (click)="generateQuote(result, 'telechargement')">
                            </p-button>
                            <p-button 
                              label="Souscrire"
                              icon="pi pi-external-link" 
                              styleClass="p-button-info w-full"
                              (click)="openAlptisPortal()">
                            </p-button>
                          </ng-container>

                          <!-- ECA: Souscrire button -->
                          <ng-container *ngIf="result.assurance.toLowerCase().includes('eca')">
                            <p-button 
                              label="Devis"
                              icon="pi pi-file-pdf" 
                              styleClass="p-button-outlined w-full"
                              (click)="generateQuote(result, 'telechargement')">
                            </p-button>
                            <p-button 
                              label="Souscrire"
                              icon="pi pi-external-link" 
                              styleClass="p-button-info w-full"
                              (click)="openEcaPortal()">
                            </p-button>
                          </ng-container>

                          <!-- Generali: Devis/Imprimer et Souscrire button -->
                          <ng-container *ngIf="result.assurance.toLowerCase().includes('generali')">
                            <p-button 
                              label="Devis"
                              icon="pi pi-file-pdf" 
                              styleClass="p-button-outlined w-full"
                              (click)="generateQuote(result, 'telechargement')">
                            </p-button>
                            <p-button 
                              label="Souscrire"
                              icon="pi pi-external-link" 
                              styleClass="p-button-info w-full"
                              (click)="openGeneraliPortal()">
                            </p-button>
                          </ng-container>
                        </ng-container>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Boutons envoyer les devis sélectionnés -->
            <div *ngIf="results.length > 0 && hasSelectedQuoteSelection()" class="flex justify-content-center gap-3 mt-4 mb-4">
              <p-button
                label="Envoyer les devis par email"
                icon="pi pi-envelope"
                styleClass="p-button-primary p-button-lg"
                (click)="sendSelectedQuotesByEmail('particulier')"
                [disabled]="!hasSelectedQuoteSelection()">
              </p-button>

              <p-button
                label="SMS RDV"
                icon="pi pi-phone"
                styleClass="p-button-warning p-button-lg"
                (click)="prepareSms('rdv')">
              </p-button>

              <p-button
                label="Renvoi DEVIS+SMS"
                icon="pi pi-comment"
                styleClass="p-button-secondary p-button-lg"
                (click)="prepareSms('devis_envoye')"
                [disabled]="!hasSelectedQuoteSelection()">
              </p-button>

              <p-button
                label="Relance SMS"
                icon="pi pi-replay"
                styleClass="p-button-help p-button-lg"
                (click)="prepareSms('relance')">
              </p-button>
            </div>

            <ng-template #noResults>
              <div class="text-center p-4">
                <i class="pi pi-info-circle text-4xl text-primary mb-3"></i>
                <p class="text-lg">
                  Aucun résultat pour le moment. Veuillez remplir les étapes
                  précédentes et cliquer sur "Comparer".
                </p>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- Navigation buttons -->
        <div class="flex justify-content-between mt-4">
          <p-button
            label="Précédent"
            icon="pi pi-chevron-left"
            styleClass="p-button-secondary"
            (click)="prevStep()"
            [disabled]="activeIndex === 0"
          ></p-button>

          <p-button
            *ngIf="activeIndex === 0"
            label="Suivant"
            icon="pi pi-chevron-right"
            iconPos="right"
            (click)="nextStep($event)"
          ></p-button>

          <div *ngIf="activeIndex === 1" class="flex gap-2">
            <p-button
              label="Comparer"
              icon="pi pi-calculator"
              iconPos="right"
              (click)="submitComparison()"
              [loading]="submitting"
              [disabled]="!insuranceForm.valid || isComparing"
            ></p-button>
            
            <p-button
              *ngIf="isComparing"
              label="ANNULER"
              icon="pi pi-times"
              styleClass="p-button-danger"
              (click)="cancelComparison()"
            ></p-button>
          </div>

          <div *ngIf="activeIndex === 2" class="flex gap-2">
            <p-button
              label="Mail Économiser"
              icon="pi pi-envelope"
              styleClass="p-button-help"
              (click)="openEconomiserEmailDialog()"
            ></p-button>
            <p-button
              label="Nouvelle comparaison"
              icon="pi pi-refresh"
              styleClass="p-button-secondary"
              (click)="resetForm()"
            ></p-button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Dialog pour afficher les détails des points faibles -->
  <p-dialog 
    header="Détails des Points Faibles" 
    [(visible)]="showWeakPointDialog" 
    [modal]="true" 
    [style]="{width: '50vw'}"
    [closable]="true">
    <div *ngIf="selectedWeakPointDetails">
          <h4 class="font-bold mb-3">{{ selectedWeakPointDetails.assurance }}</h4>
          <p class="mb-2"><strong>Point faible principal :</strong></p>
          <p class="text-gray-700 mb-4">{{ selectedWeakPointDetails.weakPoint }}</p>
          
          <div *ngIf="selectedWeakPointDetails.detailedWeakPoints && selectedWeakPointDetails.detailedWeakPoints.length > 0">
            <p class="mb-2"><strong>Détails supplémentaires :</strong></p>
            <ul class="list-disc pl-5">
              <li *ngFor="let detail of selectedWeakPointDetails.detailedWeakPoints" class="mb-1">
                {{ detail }}
              </li>
            </ul>
          </div>
          
          <div *ngIf="!selectedWeakPointDetails.detailedWeakPoints || selectedWeakPointDetails.detailedWeakPoints.length === 0">
            <p class="text-gray-500 italic">Aucun détail supplémentaire disponible.</p>
          </div>
    </div>
  </p-dialog>

  <!-- Dialog Mail Economiser -->
  <p-dialog [(visible)]="showEconomiserEmailDialog" header="Mail Économiser" [modal]="true" [draggable]="false"
      [resizable]="false" [style]="{ width: 'min(660px, 96vw)' }" [breakpoints]="{ '960px': '95vw' }"
      (onHide)="closeEconomiserEmailDialog()">
      <div class="p-fluid">
          <p class="mb-4 text-gray-600">
              Envoyez l'email « ECONOMISER SANS AUCUN RISQUE » à votre prospect avec les informations sur son assurance actuelle.
          </p>
  
          <div class="field mb-3">
              <label for="economiser-client-name" class="font-bold block mb-2">Nom du client (destinataire)</label>
              <input pInputText id="economiser-client-name" type="text" [(ngModel)]="economiserClientName"
                  placeholder="Ex. Marie DURAND" autocomplete="name" class="w-full" />
          </div>
          <div class="field mb-3">
              <label for="economiser-civility" class="font-bold block mb-2">Civilité</label>
              <select id="economiser-civility" class="w-full p-2 border-round border-1 border-gray-300" [(ngModel)]="economiserCivility">
                  <option *ngFor="let o of civiliteOptions" [ngValue]="o.label">{{ o.label }}</option>
              </select>
          </div>
          <div class="field mb-4">
              <label for="economiser-email" class="font-bold block mb-2">Email du destinataire</label>
              <input pInputText id="economiser-email" type="email" [(ngModel)]="economiserRecipientEmail"
                  placeholder="client@exemple.fr" autocomplete="email" class="w-full" />
          </div>
  
          <div class="flex justify-content-end gap-2 mt-4">
              <p-button label="Annuler" severity="secondary" [outlined]="true" (onClick)="closeEconomiserEmailDialog()"
                  [disabled]="sendingEconomiserEmail"></p-button>
              <p-button label="Envoyer l'email" icon="pi pi-send" (onClick)="confirmSendEconomiserEmail()"
                  [loading]="sendingEconomiserEmail" [disabled]="sendingEconomiserEmail" styleClass="p-button-help"></p-button>
          </div>
      </div>
  </p-dialog>

  <!-- Toast pour les notifications -->
  <p-toast></p-toast>

  <!-- Dialog d'envoi SMS -->
  <p-dialog header="Envoyer un SMS" [(visible)]="showSmsDialog" [modal]="true" [style]="{ width: '400px' }">
    <div class="flex flex-column gap-3 p-3">
      <div class="field" *ngIf="smsType === 'rdv'">
        <label for="rdvTime" class="block font-bold mb-2">Heure du RDV (ex: 14H30)</label>
        <input id="rdvTime" type="text" pInputText [(ngModel)]="rdvTime" (input)="updateSmsContent()" class="w-full" placeholder="XXHXX" />
      </div>
      <div class="field">
        <label class="block font-bold mb-2">Message</label>
        <textarea class="p-inputtext w-full" [(ngModel)]="smsContent" rows="12" style="resize: vertical;"></textarea>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button label="Annuler" icon="pi pi-times" (onClick)="showSmsDialog = false" severity="secondary" [text]="true"></p-button>
      <p-button label="Envoyer" icon="pi pi-send" (onClick)="sendSms()" [loading]="sendingSms" [disabled]="!smsContent.trim()"></p-button>
    </ng-template>
  </p-dialog>

  <!-- Dialog de confirmation -->
  <p-confirmDialog></p-confirmDialog>
</div>